import React from 'react';

function IconBase({ children, title }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
    >
      {children}
    </svg>
  );
}

export function IconGrid({ title = 'Overview' } = {}) {
  return (
    <IconBase title={title}>
      <path d="M4 4h7v7H4V4Z" stroke="currentColor" strokeWidth="1.6" />
      <path d="M13 4h7v7h-7V4Z" stroke="currentColor" strokeWidth="1.6" />
      <path d="M4 13h7v7H4v-7Z" stroke="currentColor" strokeWidth="1.6" />
      <path d="M13 13h7v7h-7v-7Z" stroke="currentColor" strokeWidth="1.6" />
    </IconBase>
  );
}

export function IconBuilding({ title = 'Enterprise' } = {}) {
  return (
    <IconBase title={title}>
      <path d="M4 20V8l8-4 8 4v12" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M9 20v-6h6v6" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M9 10h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M12 10h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M15 10h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M9 13h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M15 13h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </IconBase>
  );
}

export function IconUsers({ title = 'Users' } = {}) {
  return (
    <IconBase title={title}>
      <path d="M16 11a4 4 0 1 0-8 0 4 4 0 0 0 8 0Z" stroke="currentColor" strokeWidth="1.6" />
      <path d="M4 20a6 6 0 0 1 16 0" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </IconBase>
  );
}

export function IconLink({ title = 'Sessions' } = {}) {
  return (
    <IconBase title={title}>
      <path d="M10 13a5 5 0 0 1 0-7l1-1a5 5 0 0 1 7 7l-1 1" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M14 11a5 5 0 0 1 0 7l-1 1a5 5 0 0 1-7-7l1-1" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </IconBase>
  );
}

export function IconTrend({ title = 'Growth' } = {}) {
  return (
    <IconBase title={title}>
      <path d="M4 16l6-6 4 4 6-6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20 8v6h-6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </IconBase>
  );
}

export function IconShield({ title = 'Security' } = {}) {
  return (
    <IconBase title={title}>
      <path
        d="M12 3 20 7 20 13 C20 17 16 21 12 22 C8 21 4 17 4 13 L4 7 12 3 Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
    </IconBase>
  );
}

export function IconReceipt({ title = 'Orders' } = {}) {
  return (
    <IconBase title={title}>
      <path d="M7 3h10v18l-2-1-2 1-2-1-2 1-2-1-2 1V3Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M9 7h6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M9 11h6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M9 15h4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </IconBase>
  );
}

export function IconFileText({ title = 'Applications' } = {}) {
  return (
    <IconBase title={title}>
      <path d="M7 3h7l3 3v15H7V3Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M14 3v4h4" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M9 11h6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M9 15h6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </IconBase>
  );
}

export function IconGlobe({ title = 'Geographic' } = {}) {
  return (
    <IconBase title={title}>
      <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" stroke="currentColor" strokeWidth="1.6" />
      <path d="M3 12h18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M12 3c3 3.5 3 14 0 18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M12 3c-3 3.5-3 14 0 18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </IconBase>
  );
}

export function IconAlert({ title = 'Alert' } = {}) {
  return (
    <IconBase title={title}>
      <path d="M12 8v5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M10.3 4.3 2.8 18a1.5 1.5 0 0 0 1.3 2.2h15.8a1.5 1.5 0 0 0 1.3-2.2L13.7 4.3a1.5 1.5 0 0 0-2.6 0Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
    </IconBase>
  );
}

export function IconKey({ title = 'Staff' } = {}) {
  return (
    <IconBase title={title}>
      <circle cx="8" cy="15" r="4" stroke="currentColor" strokeWidth="1.6" />
      <path d="M11.5 13.5 20 5v4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M16 7h3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </IconBase>
  );
}

export function IconLock({ title = 'Lock' } = {}) {
  return (
    <IconBase title={title}>
      <path d="M7 11V8a5 5 0 0 1 10 0v3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M6 11h12v10H6V11Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    </IconBase>
  );
}

export function IconActivity({ title = 'Activity' } = {}) {
  return (
    <IconBase title={title}>
      <path d="M4 14l4-4 3 3 5-7 4 5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </IconBase>
  );
}

export function IconServer({ title = 'Server' } = {}) {
  return (
    <IconBase title={title}>
      <path d="M5 5h14v6H5V5Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M5 13h14v6H5v-6Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M8 8h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M8 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </IconBase>
  );
}

export function IconCheck({ title = 'Check' } = {}) {
  return (
    <IconBase title={title}>
      <path d="M5 12l4 4 10-10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </IconBase>
  );
}

export function IconDevice({ title = 'Devices' } = {}) {
  return (
    <IconBase title={title}>
      <path d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.6" />
      <path d="M10 17h4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </IconBase>
  );
}

export function IconMoon({ title = 'Dark mode' } = {}) {
  return (
    <IconBase title={title}>
      <path
        d="M21 14.5A7.5 7.5 0 0 1 9.5 3a6.8 6.8 0 0 0 11.5 11.5Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
    </IconBase>
  );
}

export function IconSun({ title = 'Light mode' } = {}) {
  return (
    <IconBase title={title}>
      <path d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" stroke="currentColor" strokeWidth="1.6" />
      <path d="M12 2v2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M12 20v2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M4 12H2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M22 12h-2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M5 5l1.4 1.4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M19 19l-1.4-1.4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M19 5l-1.4 1.4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M5 19l1.4-1.4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </IconBase>
  );
}

